import { FaWhatsapp } from "react-icons/fa";
import { WHATSAPP } from "@/constants/testIds";

export default function FloatingWhatsApp() {
  return (
    <a
      data-testid={WHATSAPP.button}
      href="https://wa.me/916364851581?text=Hi%20Spoorti%20Technologies%2C%20I%27d%20like%20to%20learn%20more%20about%20your%20AI%20%26%20IoT%20solutions."
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 left-6 z-[10000] w-14 h-14 rounded-full bg-[#25D366] text-white grid place-items-center shadow-2xl shadow-emerald-500/30 hover:scale-110 transition-transform"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" />
      <FaWhatsapp className="relative w-7 h-7" />
    </a>
  );
}
